__turbopack_context__.v({
  "hidden": "EventsCalendarMobileWeekSelector-module-scss-module__XfsBqG__hidden",
  "navButton": "EventsCalendarMobileWeekSelector-module-scss-module__XfsBqG__navButton",
  "visible": "EventsCalendarMobileWeekSelector-module-scss-module__XfsBqG__visible",
  "weekLabel": "EventsCalendarMobileWeekSelector-module-scss-module__XfsBqG__weekLabel",
  "weekLabelCurrent": "EventsCalendarMobileWeekSelector-module-scss-module__XfsBqG__weekLabelCurrent" + " " + "EventsCalendarMobileWeekSelector-module-scss-module__XfsBqG__weekLabel",
  "weekLabelOther": "EventsCalendarMobileWeekSelector-module-scss-module__XfsBqG__weekLabelOther" + " " + "EventsCalendarMobileWeekSelector-module-scss-module__XfsBqG__weekLabel",
  "wrapper": "EventsCalendarMobileWeekSelector-module-scss-module__XfsBqG__wrapper",
});
